const SALONSTOCKER_CDN_HOST = /(^|\.)cdn\.salonstocker\.com$/i;

/**
 * Master catalog images on salonstocker's CDN have a pre-generated thumbnail
 * at "<dir>/<size>/<filename>" alongside the full-size original at
 * "<dir>/<filename>" (e.g. ".../SS-01193/Foo.jpg" ->
 * ".../SS-01193/160Wx160H/Foo.jpg"). Rewriting an `<img>` src to the smaller
 * variant avoids downloading the full-size original (often several hundred
 * KB) just to render a small product tile.
 *
 * No-ops - returns `url` unchanged - for anything that isn't an absolute
 * salonstocker CDN URL (supplier-hosted images live on arbitrary other CDNs)
 * or that fails to parse as a URL at all.
 */
export function toThumbnailUrl(url: string, size = "160Wx160H"): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (!SALONSTOCKER_CDN_HOST.test(parsed.hostname)) return url;
  const slashIdx = parsed.pathname.lastIndexOf("/");
  if (slashIdx < 0) return url;
  parsed.pathname = `${parsed.pathname.slice(0, slashIdx)}/${size}${parsed.pathname.slice(slashIdx)}`;
  return parsed.toString();
}
